'use client';
import styled from 'styled-components';
import { FormFieldsContainer, FormWrapper } from '../FormFieldsContainer';

export const BreedFormWrapper = styled(FormWrapper)`
  min-height: ${props =>
    props.$minHeight ? `${props.$minHeight}px` : '253px'};
  overflow-y: auto;
  overflow-x: visible;

  @media ${props => props.theme.laptop} {
    overflow: hidden;
  }
`;

export const BreedFormFieldsContainer = styled(FormFieldsContainer)`
  box-sizing: border-box;
  padding: 0 ${({ theme }) => theme.spacing(5)};
  width: 100%;
  justify-content: flex-start;
  flex: 1;
`;

export const FieldWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;

export const Subheadline = styled.p`
  margin: ${({ theme }) => theme.spacing(3, 0, 0)};
  padding: 0;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const ImageContainer = styled.div`
  position: fixed;
  top: 82px;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
  }
  @media ${props => props.theme.laptop} {
    position: relative;
    top: 0;
    height: calc(100% - 92px);
    width: 50%;
    img {
      object-fit: cover;
    }
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;
  height: 100%;

  @media ${props => props.theme.laptop} {
    display: flex;
    img {
      height: 100vh !important;
    }
  }
`;
export const MobileImageContainer = styled.div`
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  position: absolute;
  top: 15px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    background-color: color-mix(
      in srgb,
      ${props => props.theme.colors.neutral.darkest} 70%,
      transparent
    );
    border: none;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: ${props => props.theme.spacing(6)};
  margin-bottom: ${props => props.theme.spacing(8)};
  width: 100%;
`;
